import React from 'react';
import T from 'prop-types';
import cx from 'classnames';
import ReleasesChart from '../charts/ReleasesChart';
import RanksChangeChart from '../charts/RanksChangeChart';

const content = [
  { header: 'Rank History', description: '% Change over Time' },
  { header: 'Releases', description: 'Avg Update Time' },
  { header: 'Market Analysis', description: 'Market Growth Trends, Change in Market Share' },
  {
    header: 'User Statistics',
    description: 'New User Growth, Happiest Users, Stickiest Users, Retention',
  },
  { header: 'Voice of Customer', description: 'Review Volume & Review Sentiment' },
];

const Slide = ({ id, selectedApps, reportCharts, setUserFormModalOpen, setEditMode }) => {
  const isChart = id === 0 || id === 1;
  const isRelease = id === 1;
  return (
    <div
      className={cx('slide-content', { 'slide-content-disabled-box': !isChart })}
      onClick={() => !isChart && setUserFormModalOpen(true)}
    >
      <div className="slide-content-head">
        <h3 className="slide-content-head-header">{content[id] && content[id].header}</h3>
        <p className="slide-content-head-description">{content[id] && content[id].description}</p>
      </div>
      {isChart ? (
        <div className="slide-content-chart">
          {!isRelease && (
            <RanksChangeChart series={reportCharts.ranks_history} selectedApps={selectedApps} />
          )}
          {isRelease && (
            <ReleasesChart series={reportCharts.releases} selectedApps={selectedApps} />
          )}
          <div className={cx('slide-content-button', isRelease && 'd-flex align-items-center')}>
            {isRelease && (
              <div className="slides-chart-legend-item">
                <span
                  className="slides-chart-legend-item-bullet m-a-0"
                  style={{ backgroundColor: '#15385B' }}
                />
                <span className="slides-chart-legend-item-name w-100">Market Average</span>
              </div>
            )}
            <button className="hms-btn hms-btn-primary" onClick={() => setEditMode(true)}>
              Edit Competitors
            </button>
          </div>
        </div>
      ) : (
        <div className="slide-content-disabled">
          <div className={cx(`slide-content-button-box-${id}`)}>
            <div className="button-get">
              <span className="button-get-icon">
                <i className="hicon-lock" />
              </span>
              <span className="button-get-text">Unlock This Data</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

Slide.propTypes = {
  id: T.number.isRequired,
  selectedApps: T.array.isRequired,
  reportCharts: T.object.isRequired,
  setUserFormModalOpen: T.func.isRequired,
  setEditMode: T.func.isRequired,
};

export default Slide;
